module.exports = __webpack_public_path__ + "static/img/zx1.e158c69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/zx1.jpg
// module id = Bg5q
// module chunks = 49